import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";

export function updateEventBusinessAuthorizations(_event_id, _business_authorizations) {
    console.log("updateEventBusinessAuthorizations : ", _business_authorizations);

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // write back
                event.business_authorizations = _business_authorizations;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Event with ID ${_event_id} updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred during updateEventActivity:", error);
            throw error;
        });
}